<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { useMate } from "@/stores/mate";
import { CountDown, showLoadingToast, showSuccessToast } from "vant";

const props = defineProps<{
  email: string;
  verifyCode: string;
  nextResendTime: number;
  sendVerificationCode: () => Promise<void>;
}>();
const emit = defineEmits<{
  (e: "update:email", value: string): void;
  (e: "update:verifyCode", value: string): void;
  (e: "update:nextResendTime", value: number): void;
  (e: "onAvatarClick"): void;
}>();
const { t } = useI18n();

const mateStore = useMate();
const onSendCode = async () => {
  const loading = showLoadingToast("");
  try {
    await props.sendVerificationCode();
    loading.close();
    showSuccessToast(t("loginmodal.verifyCodeSentSuccess"));
  } finally {
    loading.close();
  }
};
</script>
<template>
  <div class="flex flex-col gap-10 items-center justify-center">
    <div class="text-white text-[2rem] font-bold text-center">
      {{ $t("loginmodal.theLastStep") }}
    </div>
    <div class="flex flex-col gap-2 items-center">
      <div
        class="rounded overflow-hidden shadow-lg aspect-[3/4] w-32 md:w-64 items-center justify-center"
        @click="emit('onAvatarClick')"
      >
        <VanImage
          :src="`${mateStore.currentMate!.mediaUrl}?x-oss-process=image/resize,w_300/format,webp`"
          class="w-full aspect-[3/4]"
          fit="object-contain pointer-events-none"
        >
          <template v-slot:loading>
            <span class="loading loading-sm loading-ring" />
          </template>
        </VanImage>
      </div>
      <div class="flex flex-col gap-2 w-[20rem]">
        <div class="flex gap-2 bg-neutral rounded items-center pr-1">
          <input
            :placeholder="$t('loginmodal.enterEmail')"
            :value="props.email"
            class="input input-ghost focus:outline-0 focus:bg-transparent flex-1"
            type="email"
            @input="emit('update:email', $event.target?.value)"
          />
          <button
            v-if="nextResendTime === 0"
            :disabled="props.email.length === 0"
            class="btn-ghost btn btn-xs"
            @click="onSendCode"
          >
            {{ $t("loginmodal.sendcode") }}
          </button>
          <button v-else class="btn-ghost btn btn-xs" disabled>
            <span
              ><count-down
                :time="nextResendTime - Date.now()"
                class="inline-block text-inherit"
                format="ss"
                @finish="emit('update:nextResendTime', 0)"
              />
              s</span
            >
          </button>
        </div>
        <div class="flex gap-2 bg-neutral rounded items-center pr-1">
          <input
            :placeholder="$t('loginmodal.verificationcode')"
            :value="props.verifyCode"
            class="input input-ghost focus:outline-0 focus:bg-transparent flex-1 w-full"
            type="text"
            @input="emit('update:verifyCode', $event.target?.value)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
